import Tabs from '../../../components/AnimatedTabs';
import { Space, } from 'antd';
import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

export default function DoctorInspection() {
  const { doctorId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const base = `/superadmin/doctors/${doctorId}`;
  const active = pathname.endsWith('/appointments') ? 'appointments' : pathname.endsWith('/settings') ? 'settings' : '';
  return <>
    <Space wrap style={{ marginBottom: 16 }}>
      <Link to="/superadmin/doctors">← Back to doctors</Link>
      <span>Viewing doctor workspace as superadmin</span>
    </Space>
    <Tabs activeKey={active} onChange={key => navigate(`${base}${key ? `/${key}` : ''}`)} items={[
      { key: '', label: 'Overview' },
      { key: 'appointments', label: 'Appointments' },
      { key: 'settings', label: 'Doctor profile' },
    ]} />
    <Outlet />
  </>;
}
